// utils/dateFormatter.js
import { format } from "date-fns";

export const formatDate = (
  dateString: any,
  formatPattern = "MMMM dd, yyyy hh:mm a"
) => {
  try {
    const utcDate = new Date(dateString); // Interpret as UTC
    // Adjust to local timezone
    const localDate = new Date(
      utcDate.getTime() + utcDate.getTimezoneOffset() * 60000
    );

    return format(localDate, formatPattern);
  } catch {
    return "Invalid Date";
  }
};

export const getTodaysDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const day = String(today.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
